export const subheaderActionsPrivilegeValidator = (actions: any[]) => {
    return actions.filter((action) => action?.style?.display !== 'none');
};